// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function TcItemDistributionChart(Props) {
  var carryUnits = Props.carryUnits;
  var maxC = Caml.caml_float_max(Caml_splice_call.spliceApply(Math.max, [Belt_Array.map(carryUnits, (function (prim) {
                    return prim[1];
                  }))]), 2.75);
  return React.createElement("div", {
              className: "flex flex-col leading-none font-montserrat text-base font-semibold"
            }, Belt_Array.map(Belt_Array.slice(carryUnits, 0, 4), (function (param) {
                    var c = param[1];
                    var unitId = param[0];
                    return React.createElement("div", {
                                key: unitId,
                                className: "pt-[8px] flex items-center"
                              }, React.createElement(UnitImage.make, {
                                    unitId: unitId,
                                    size: 34
                                  }), React.createElement("div", {
                                    className: "mx-2 bg-secondary-9 h-[18px]",
                                    style: Global.s({
                                          width: (c / maxC * 175).toFixed() + "px"
                                        })
                                  }), Global.toFixed(undefined, c));
                  })));
}

var make = TcItemDistributionChart;

export {
  make ,
  
}
/* react Not a pure module */
